import { AirplaneTilt, Globe } from "@phosphor-icons/react";
import { Button } from "@flight-tools/ui";
import { useLanguageSwitcher, useTranslation } from "@flight-tools/i18n";

export function Header() {
  const { t } = useTranslation("common");
  const { currentLanguage, changeLanguage, languages } = useLanguageSwitcher();

  return (
    <header className="border-b border-border/50 bg-card/30 backdrop-blur-sm">
      <div className="container mx-auto px-4 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-gradient-to-br from-primary to-accent">
              <AirplaneTilt weight="duotone" className="h-6 w-6 text-white" />
            </div>
            <div>
              <h1 className="text-lg font-semibold">{t("appName")}</h1>
              <p className="text-xs text-muted-foreground">{t("subtitle")}</p>
            </div>
          </div>

          <div className="flex items-center gap-2">
            <Globe className="h-4 w-4 text-muted-foreground" />
            <div className="flex gap-1">
              {languages.map((lang) => (
                <Button
                  key={lang}
                  variant={currentLanguage === lang ? "default" : "ghost"}
                  size="sm"
                  onClick={() => changeLanguage(lang)}
                  className="min-w-[40px] text-xs"
                >
                  {lang.toUpperCase()}
                </Button>
              ))}
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}
